import Vas from '../Vas';
import React from 'react';
import { Panel } from 'component-lib';
import { Link } from 'react-router-dom';
import { RoleConfiguration } from 'utils-lib';

class PanelsLinks
{
    constructor(){
        this.tasks = '';
        this.customers= '';
        this.contracts= '';
        this.account= '';
        this.configuration = '';
        this.administration= '';
        this.accounts= '';
        this.documentsUpload= '';
        this.documentsDownload= '';
        this.history= '';
    }
    
    static HomePanels(me,Count)
    {
        let role = localStorage.getItem("vas_role");
        let rights = RoleConfiguration.getRoleConfig();
        if (Vas.Debug)
        {if (rights){
            if (role === "1")//Schüler
            {
                PanelsLinks.role1("home",rights,me);
            }

            if (role === "2"){//Schule/Schulträger
                PanelsLinks.role2("home",rights,me);
            }

            if (role === "3") //Sachbearbeiter
            {
                PanelsLinks.role3("home",rights,me,Count);
            }
        }}
        
        if (role === "99")//Admin
        {
            PanelsLinks.role99("home",me,Count);
        }
//#endregion
        
//#region panels auf Seitenbreite einstellen
        let arr = [this.tasks,this.customers,this.contracts,this.account,this.configuration,this.administration,this.accounts,this.documentsUpload,this.documentsDownload,this.history];
        return arr;
    }

    static SideNav(){
        let role = localStorage.getItem("vas_role");
        let rights = RoleConfiguration.getRoleConfig();
        if (rights){
            if (role === "1")//Schüler
            {
                PanelsLinks.role1("",rights);
            }
            if (role === "2"){//Schule/Schulträger
                PanelsLinks.role2("",rights);
            }

            if (role === "3") //Sachbearbeiter
            {
                PanelsLinks.role3("",rights);
            }
        }
        
        if (role === "99")//Admin
        {
            PanelsLinks.role99("");
        }

        let arr = [this.tasks,this.customers,this.contracts,this.account,this.configuration,this.administration,this.accounts,this.documentsUpload,this.documentsDownload, this.history];

        return arr;
    }

    static role1(value,rights,me){
      if (value === "home"){
        if (rights){
          if (rights[5]){
            if (rights[5].Read === true){
              this.account = (<Panel
                C={'c1'}
                HeaderIcon={"Account"}
                Header={Vas.Resources.Labels["MyAccount"]}
                Id={"Account2"}
                Drag={true}
                ref={"Account2"}
                reference={me}
                Right={rights[5]} 
                read={<div className={"panelLink"} > <Link
                  className={"link"}
                  to={"/account"}> {Vas.Resources.Labels["MyAccount"]}</Link></div>}
                      
              />);
            }
          }
          
          if (rights[3]){
            if (rights[3].Read === true){
              this.contracts = (<Panel
                C={'c2'}
                HeaderIcon={"Contracts"}
                Header={Vas.Resources.Labels["Contracts"]}
                Id={"Contracts"}
                Drag={true}
                ref={"Contracts"}
                reference={me}
                Right={rights[3]}
                read={<div className={"panelLink"} ><Link
                  className={"link"}
                  to={"/contracts/false"}>{Vas.Resources.Labels["MyContracts"]}</Link></div>} 
            />);
            }
          }
                    
          if (rights[1]){
            if (rights[1].Read === true){
              this.customers = (<Panel
                C={'c5'}
                HeaderIcon={"Customers"}
                Header={Vas.Resources.Labels["Data"]}
                Id={"Customers"}
                Drag={true}
                ref={"Customers"}
                reference={me}
                Right={rights[1]} 
                read={<div className={"panelLink"} > <Link
                  className={"link"}
                  to={"/customerCard/"+ localStorage.getItem("vas_customerId")} >{Vas.Resources.Labels["MyData"]}</Link></div>} 
                          />);
            }
          }
                      
          this.configuration = (<Panel
            C={'c3'}
            HeaderIcon={"Settings"}
            Header={Vas.Resources.Menus["Configuration"]}
            Id={"Configuration"}
            Drag={true}
            ref={"Configuration"}
            reference={me}
            Content={<div className={"panelLink"}> <Link 
              className={"link"} 
              to={"/configuration"}> {Vas.Resources.Labels["Language"]}
            </Link></div>} />);

          if (rights[6]){
            if (rights[6].Read === true){
              this.documentsDownload = (<Panel
                C={'c4'}
                HeaderIcon={"Contracts"}
                Header={Vas.Resources.Labels["Forms"]}
                Id={"Forms"}
                Drag={true}
                ref={"Forms"}
                reference={me}
                Right={rights[6]}
                read={<div className={"panelLink"}><Link
                  className={"link"}
                  to={"/documentDownload"}>{Vas.Resources.Labels["FormsDownload"]}</Link></div>} 
              />);
            }
          }
        }
      } else {
          //[HeaderIcon,to,Labeltext,panelID]
          if (rights[5]){
              if (rights[5].Read === true){
                  this.account=["Account","/account",Vas.Resources.Menus["Account"],"Account2"];
              } 
          }
          
          if (rights[3]){
              if (rights[3].Read === true){
                  this.contracts=["Contracts","/contracts/false",Vas.Resources.Labels["Contracts"],"Contracts"];
              }  
          }
          
          if (rights[1]){
              if (rights[1].Read === true){
                  this.customers=["Customers","/customerCard/"+ localStorage.getItem("vas_customerId"),Vas.Resources.Labels["Data"],"Customers"];
              }  
          }
                        
          this.configuration=["Settings","/configuration",Vas.Resources.Menus["Configuration"],"Configuration"];

          if (rights[6]){
              if (rights[6].Read === true){
                  this.documentsDownload=["Contracts","/documentDownload",Vas.Resources.Labels["FormsDownload"],"Forms"];
              } 
          }          
      }
    }

    static role2(value,rights,me){
        if (value === "home"){
            this.documentsUpload = (<Panel
              C={'c2'}
              HeaderIcon={"Contracts"}
              Header={Vas.Resources.Labels["Forms"]}
              Id={"Forms"}
              Drag={true}
              ref={"Forms"}
              reference={me}
              Right={rights[6]}
              create={<div className={"panelLink"}><Link
                className={"link"}
                to={"/documentUpload"}>{Vas.Resources.Labels["FormsUpload"]}</Link></div>} 
            />);

            this.configuration = (<Panel
              C={'c1'}
              HeaderIcon={"Settings"}
              Header={Vas.Resources.Menus["Configuration"]}
              Id={"Configuration"}
              Drag={true}
              ref={"Configuration"}
              reference={me}
              Content={<div className={"panelLink"} > <Link 
                className={"link"} 
                to={"/configuration"}> {Vas.Resources.Labels["Language"]}
              </Link></div>} />);
        } else {
            if (rights[6]){
                if (rights[6].Create === true){
                    this.documentsUpload = ["Contracts","/documentUpload",Vas.Resources.Labels["Forms"],"Forms"];
                }  
            }
            this.configuration = ["Settings","/configuration",Vas.Resources.Menus["Configuration"],"Configuration"];
        }
    }

    static role3(value,rights,me,count){
        if (value === "home"){
          if (rights){
            this.tasks = (<Panel
              C={'c1'}
              HeaderIcon={"Tasks"}
              Header={Vas.Resources.Labels["Tasks"]}
              Id={"Tasks"}
              Drag={true}
              ref={"Tasks"}
              reference={me}
              Content={
                <div className={"panelLink"} ><Link 
                  className={"link"} 
                  to={"/contracts/false"}> {<div><div style={{ textDecoration:"underline",float:"left" }}>{Vas.Resources.Labels["CheckContracts"]}</div><div style={{ float:"right" }}>{"(" + count +")"}</div></div>}
                </Link></div>
            } />);

            if (rights[0]){
              if (rights[0].Read=== true){
                this.customers = (<Panel
                  C={'c2'}
                  HeaderIcon={"Customers"}
                  Header={Vas.Resources.Labels["Customers"]}
                  Id={"Customers"}
                  Drag={true}
                  ref={"Customers"}
                  reference={me}
                  Right={rights[0]} 
                  read={<div className={"panelLink"} ><Link
                    className={"link"}
                    to={"/customers"}> {Vas.Resources.Labels["OverviewCustomers"]}</Link></div>} 
                  create={<div className={"panelLink"} ><Link
                    className={"link"}
                    to={"/createCustomer"}> {Vas.Resources.Labels["CreateCustomer"]}</Link></div>} 
                />);
              }
            }

            if (rights[5]){
              if (rights[5].Read === true){
                this.account = (<Panel
                  C={'c4'}
                  HeaderIcon={"Account"}
                  Header={Vas.Resources.Labels["MyAccount"]}
                  Id={"Account2"}
                  Drag={true}
                  ref={"Account2"}
                  reference={me}
                  Right={rights[5]}
                  read={<div className={"panelLink"} ><Link
                    className={"link"}
                    to={"/account"}> {Vas.Resources.Labels["MyAccount"]}</Link></div>} 
                        />);
              }
            }

            if (rights[4]){
              if (rights[4].Read === true){
                this.accounts = (<Panel
                  C={'c5'}
                  HeaderIcon={"Account"}
                  Header={Vas.Resources.Labels["Accounts"]}
                  Id={"Accounts"}
                  Drag={true}
                  ref={"Accounts"}
                  reference={me}
                  Right={rights[4]}
                  read={<div className={"panelLink"} ><Link
                    className={"link"}
                    to={"/accounts"}> {Vas.Resources.Labels["OverviewAccounts"]}</Link></div>} 
                        />);
              }
            }

            this.configuration = (<Panel
              C={'c6'}
              HeaderIcon={"Settings"}
              Header={Vas.Resources.Menus["Configuration"]}
              Id={"Configuration"}
              Drag={true}
              ref={"Configuration"}
              reference={me}
              Content={<div className={"panelLink"} > <Link 
                className={"link"} 
                to={"/configuration"}> {Vas.Resources.Labels["Language"]}
              </Link></div>} />);

            if (rights[2]){
              if (rights[2].Read === true){
                this.contracts = (<Panel
                  C={'c7'}
                  HeaderIcon={"Contracts"}
                  Header={Vas.Resources.Labels["Contracts"]}
                  Id={"Contracts"}
                  Drag={true}
                  ref={"Contracts"}
                  reference={me}
                  Right={rights[2]}
                  read={<div className={"panelLink"}><Link
                    className={"link"}
                    to={"/contracts/true"} > {Vas.Resources.Labels["OverviewContracts"]}</Link></div>} 
                        />);
              }
            }

            this.documentsUpload = (<Panel
              C={'c8'}
              HeaderIcon={"Contracts"}
              Header={Vas.Resources.Labels["Forms"]}
              Id={"Forms2"}
              Drag={true}
              ref={"Forms2"}
              reference={me}
              Content={
                <div className={"panelLink"}><Link 
                  className={"link"} 
                  to={"/documentUpload"}>{Vas.Resources.Labels["FormsManage"]}
                </Link></div>} 
            />);

            this.history = (<Panel
              C={'c9'}
              HeaderIcon={"Tasks"}
              Header={Vas.Resources.Labels["Logbook"]}
              Id={"History"}
              Drag={true}
              ref={"History"}
              reference={me}
              Content={
                <div className={"panelLink"} ><Link 
                  className={"link"} 
                  to={"/schoolHistory"}> {<div><div style={{ textDecoration:"underline",float:"left" }}>{Vas.Resources.Labels["SchoolHistory"]}</div></div>}
                </Link></div>
            } />);
          }

            //test = <Panel C={'c8'} HeaderIcon={"Schools"} Header={"Test"} Content={""} Id={"Test"} Drag={true} ref={"Test"} reference={this}/>;
            //test1 = <Panel C={'c9'} HeaderIcon={"Schools"} Header={"Test1"} Content={"BLUBBB"} Id={"Test1"} Drag={true} ref={"Test1"} reference={this}/>;
            //test2 = <Panel C={'c10'} HeaderIcon={"Schools"} Header={"Test2"} Content={""} Id={"Test2"} Drag={true} ref={"Test2"} reference={this}/>;
        } else {
            this.tasks = ["Tasks","/contracts/false",Vas.Resources.Labels["Tasks"],"Tasks"];

            if (rights[0]){
                if (rights[0].Read){
                    this.customers = ["Customers","/customers",Vas.Resources.Labels["Customers"],"Customers"];
                } 
            }
                        
            if (rights[5]){
                if (rights[5].Read === true){
                    this.account = ["Account","/account",Vas.Resources.Menus["Account"],"Account2"];
                }
            }
            
            if (rights[4]){
               if (rights[4].Read === true){
                    this.accounts = ["Account","/accounts",Vas.Resources.Labels["Accounts"],"Accounts"];
                } 
            }
                        
            this.configuration=["Settings","/configuration",Vas.Resources.Menus["Configuration"],"Configuration"];

            if (rights[2]){
                if (rights[2].Read === true){
                    this.contracts = ["Contracts","/contracts/true",Vas.Resources.Labels["Contracts"],"Contracts"];
                } 
            }
            this.documentsUpload = ["Contracts","/documentUpload",Vas.Resources.Labels["FormsManage"],"Forms2"];

            this.history = ["Tasks","/schoolHistory",Vas.Resources.Labels["SchoolHistory"],"History"];
           
        }
    }

    static role99(value,me,count){
        if (value === "home"){
            this.customers = (<Panel
              C={'c1'}
              HeaderIcon={"Customers"}
              Header={Vas.Resources.Labels["Customers"]}
              Id={"Customers"}
              Drag={true}
              ref={"Customers"}
              reference={me}
              Content={
                <div>
                  <div className={"panelLink"} ><Link 
                    className={"link"} 
                    to={"/customers"}> {Vas.Resources.Labels["OverviewCustomers"]}
                  </Link></div>
                  <div className={"panelLink"} ><Link 
                    className={"link"} 
                    to={"/createCustomer"}> {Vas.Resources.Labels["CreateCustomer"]}
                  </Link></div>
                </div>
            } />);

            this.account = (<Panel
              C={'c2'}
              HeaderIcon={"Account"}
              Header={Vas.Resources.Labels["MyAccount"]}
              Id={"Account2"}
              Drag={true}
              ref={"Account2"}
              reference={me}
              Content={
                <div>
                  <div className={"panelLink"} ><Link 
                    className={"link"} 
                    to={"/account"}> 
                    {Vas.Resources.Labels["MyAccount"]}
                  </Link></div>
                </div>
            } />);

            this.accounts = (<Panel
              C={'c3'}
              HeaderIcon={"Account"}
              Header={Vas.Resources.Labels["Accounts"]}
              Id={"Accounts"}
              Drag={true}
              ref={"Accounts"}
              reference={me}
              Content={
                <div className={"panelLink"} ><Link 
                  className={"link"} 
                  to={"/accounts"}> 
                  {Vas.Resources.Labels["OverviewAccounts"]}
                </Link></div>
            } />);

            this.contracts = (<Panel
              C={'c4'}
              HeaderIcon={"Contracts"}
              Header={Vas.Resources.Labels["Contracts"]}
              Id={"Contracts"}
              Drag={true}
              ref={"Contracts"}
              reference={me}
              Content={
                <div className={"panelLink"}><Link 
                  className={"link"} 
                  to={"/contracts/true"}> 
                  {Vas.Resources.Labels["OverviewContracts"]}
                </Link></div>
            } />);

            this.documentsDownload = (<Panel
              C={'c5'}
              HeaderIcon={"Contracts"}
              Header={Vas.Resources.Labels["Forms"]}
              Id={"Forms"}
              Drag={true}
              ref={"Forms"}
              reference={me}
              Content={
                <div>
                  <div className={"panelLink"}>
                    <Link 
                      className={"link"} 
                      to={"/documentUpload"}>
                      {Vas.Resources.Labels["FormsUpload"]}
                    </Link>
                  </div>
                  <div className={"panelLink"}>
                    <Link 
                      className={"link"} 
                      to={"/documentDownload"}>
                      {Vas.Resources.Labels["FormsDownload"]}
                    </Link>
                  </div>
                </div>}
            />);

            this.documentsUpload= '';
            
            this.tasks = (<Panel
              C={'c7'}
              HeaderIcon={"Tasks"}
              Header={Vas.Resources.Labels["Tasks"]}
              Id={"Tasks"}
              Drag={true}
              ref={"Tasks"}
              reference={me}
              Content={
                <div className={"panelLink"} > <Link 
                  className={"link"} 
                  to={"/contracts/false"}> 
                  {<div><div style={{ textDecoration:"underline",float:"left" }}>{Vas.Resources.Labels["CheckContracts"]}</div><div style={{ float:"right" }}>{"(" + count +")"}</div></div>}
                </Link></div>
            } />);

            this.configuration = (<Panel
              C={'c9'}
              HeaderIcon={"Settings"}
              Header={Vas.Resources.Menus["Configuration"]}
              Id={"Configuration"}
              Drag={true}
              ref={"Configuration"}
              reference={me}
              Content={<div className={"panelLink"} ><Link 
                className={"link"} 
                to={"configuration"}> 
                {Vas.Resources.Labels["Language"]}
              </Link></div>} />);
            this.administration = (<Panel
              C={'c10'}
              HeaderIcon={"Administration"}
              Header={Vas.Resources.Menus["Administration"]}
              Id={"Administration"}
              Drag={true}
              ref={"Administration"}
              reference={me}
              Content={<div className={"panelLink"} ><Link 
                className={"link"} 
                to={"/roleManagement"}>
                {Vas.Resources.Labels["RoleManagement"]}
              </Link></div>} />);
        } else {
            this.customers = ["Customers","/customers",Vas.Resources.Labels["Customers"],"Customers"];

            this.account = ["Account","/account",Vas.Resources.Menus["Account"],"Account2"];

            this.accounts = ["Account","/accounts",Vas.Resources.Labels["Accounts"],"Accounts"];

            this.contracts = ["Contracts","/contracts/true",Vas.Resources.Labels["Contracts"],"Contracts"];

            this.documentsDownload=["Contracts","/documentDownload",Vas.Resources.Labels["FormsDownload"],"Forms"];

            this.documentsUpload = ["Contracts","/documentUpload",Vas.Resources.Labels["FormsUpload"],"Forms2"];
            
            this.tasks = ["Tasks","/contracts/false",Vas.Resources.Labels["Tasks"],"Tasks"];

            this.configuration=["Settings","/configuration",Vas.Resources.Menus["Configuration"],"Configuration"];
            this.administration = ["Administration","/roleManagement",Vas.Resources.Menus["Administration"],"Administration"]; 
        }
    }
}
export default PanelsLinks;
